import _defineProperty from "/runner/_work/miro-site/miro-site/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _extends from "/runner/_work/miro-site/miro-site/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import classNames from 'classnames';
import React, { useEffect, useState } from 'react';
import { Col, Container, Row } from '@miro-site/ui-design-system';
import { HeaderLogo } from './components/header-logo';
import { NavBarMetaMenu } from './components/meta-menu';
import { NavBar } from './components/nav-bar';
import { NavDrawerTrigger } from './components/nav-drawer';
import { NavDrawer } from './components/nav-drawer';
import { HeaderDataContextProvider } from './providers/header-data-context-provider';
import { HeaderStateContextProvider } from './providers/header-state-context-provider';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var Header = function Header(props) {
  var headerData = _extends({}, props);

  var isTransparentHeader = true;
  var isFluidHeader = true;

  var _useState = useState(isTransparentHeader),
      showTransparentHeader = _useState[0],
      setShowTransparentHeader = _useState[1];

  useEffect(function () {
    if (!isTransparentHeader) {
      return;
    }

    var handleScroll = function handleScroll() {
      if (window.scrollY === 0 && !showTransparentHeader) {
        setShowTransparentHeader(true);
        return;
      }

      if (window.scrollY !== 0 && showTransparentHeader) {
        setShowTransparentHeader(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return function () {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [showTransparentHeader, isTransparentHeader]);
  var menuTree = headerData; // TODO

  var shouldUseNewHeader = false;

  if (shouldUseNewHeader) {
    var _headerData$menu, _headerData$menu2, _headerData$menu3, _headerData$menu4;

    menuTree = _objectSpread(_objectSpread({}, menuTree), {}, {
      productNavigation: (_headerData$menu = headerData.menu) === null || _headerData$menu === void 0 ? void 0 : _headerData$menu[0],
      solutionsNavigation: (_headerData$menu2 = headerData.menu) === null || _headerData$menu2 === void 0 ? void 0 : _headerData$menu2[1],
      resourcesNavigation: (_headerData$menu3 = headerData.menu) === null || _headerData$menu3 === void 0 ? void 0 : _headerData$menu3[2],
      pricingLink: (_headerData$menu4 = headerData.menu) === null || _headerData$menu4 === void 0 ? void 0 : _headerData$menu4[3],
      enterpriseNavigation: undefined,
      customersLink: undefined,
      whatsNew: undefined,
      menu: undefined
    });
  }

  return /*#__PURE__*/_jsx(HeaderDataContextProvider, {
    value: menuTree,
    children: /*#__PURE__*/_jsxs(HeaderStateContextProvider, {
      children: [/*#__PURE__*/_jsx("div", {
        className: classNames({
          'bg-white border-bottom': !showTransparentHeader
        }),
        style: {
          transition: 'background-color 100ms'
        },
        children: /*#__PURE__*/_jsx(Container, {
          fluid: isFluidHeader,
          children: /*#__PURE__*/_jsx(Row, {
            children: /*#__PURE__*/_jsxs(Col, {
              className: "d-flex gap-100 py-200 justify-content-between",
              children: [/*#__PURE__*/_jsxs("div", {
                className: "d-flex",
                children: [/*#__PURE__*/_jsx(NavDrawerTrigger, {}), /*#__PURE__*/_jsx(HeaderLogo, {}), /*#__PURE__*/_jsx(NavBar, {
                  style: {
                    transition: 'all 100ms'
                  }
                })]
              }), /*#__PURE__*/_jsx(NavBarMetaMenu, {})]
            })
          })
        })
      }), /*#__PURE__*/_jsx(NavDrawer, {})]
    })
  });
};
export default Header;